import { __extends } from "tslib";
import { RenderHtml } from '../../../utils';
import { componentViewerTranslate } from '../../translations';
import * as React from 'react';
var StepByStepComponent = /** @class */ (function (_super) {
    __extends(StepByStepComponent, _super);
    function StepByStepComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            visibleStepIndex: 0
        };
        _this.buttonRef = function (elem) {
            if (elem) {
                elem.addEventListener('click', function (_) {
                    if (document.activeElement && document.activeElement.blur) {
                        document.activeElement.blur();
                    }
                });
            }
        };
        return _this;
    }
    StepByStepComponent.prototype.showNextStep = function () {
        var componentValue = this.props.value;
        var maxIndex = componentValue.steps.length - 1;
        var possibleNextStepIndex = this.state.visibleStepIndex + 1 > maxIndex ? 0 : this.state.visibleStepIndex + 1;
        var visibleStepIndex = componentValue.allowCircular ? possibleNextStepIndex : this.state.visibleStepIndex;
        this.setState({ visibleStepIndex: visibleStepIndex });
    };
    StepByStepComponent.prototype.showPreviousStep = function () {
        var componentValue = this.props.value;
        var minIndex = 0;
        var currentIndex = this.state.visibleStepIndex;
        var stepsCount = componentValue.steps.length;
        var possiblePreviousStepIndex = currentIndex - 1 < minIndex ? stepsCount - 1 : currentIndex - 1;
        var visibleStepIndex = componentValue.allowCircular ? possiblePreviousStepIndex : this.state.visibleStepIndex;
        this.setState({ visibleStepIndex: visibleStepIndex });
    };
    StepByStepComponent.prototype.renderStep = function (step) {
        var stepImageCss = {
            backgroundImage: "url(" + step.image.src + ")"
        };
        var stepImage = React.createElement("div", { className: 'step-image', style: stepImageCss });
        var maybeLinkedImage = step.image.link ? React.createElement("a", { href: step.image.link, target: '_blank' }, stepImage) : stepImage;
        var totalStepsCount = "" + this.props.value.steps.length;
        var currentStepNumber = "" + (this.state.visibleStepIndex + 1);
        var translate = componentViewerTranslate(this.props.locale);
        var stepCountTitle = translate("components.step-by-step.step-count", {
            step: currentStepNumber,
            totalSteps: totalStepsCount
        });
        return (React.createElement("div", { className: "step-content " + this.props.value.layout },
            React.createElement("div", { tabIndex: 0, ref: this.buttonRef, className: 'step-text-wrapper' },
                React.createElement("div", { className: 'step-count-title' },
                    React.createElement(RenderHtml, { html: stepCountTitle })),
                React.createElement("h4", { className: 'step-title' }, step.title),
                React.createElement("div", { className: 'step-description' },
                    React.createElement(RenderHtml, { html: step.html, className: 'rendered-html' }))),
            maybeLinkedImage));
    };
    StepByStepComponent.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var onClickPreviousStep = function () { return _this.showPreviousStep(); };
        var onClickNextStep = function () { return _this.showNextStep(); };
        return (React.createElement("div", { className: 'component step-by-step-component', "data-component-type": 'step-by-step' },
            React.createElement("div", { className: "step-by-step-component-wrapper " + props.value.layout },
                React.createElement("div", { className: 'pagination-button-wrapper previous', onClick: onClickPreviousStep },
                    React.createElement("button", { ref: this.buttonRef, className: 'arrow previous-step' })),
                React.createElement("div", { className: 'current-step', "data-component-step": this.state.visibleStepIndex + 1 }, this.renderStep(this.props.value.steps[this.state.visibleStepIndex])),
                React.createElement("div", { className: 'pagination-button-wrapper next', onClick: onClickNextStep },
                    React.createElement("button", { ref: this.buttonRef, className: 'arrow next-step' })))));
    };
    return StepByStepComponent;
}(React.Component));
export { StepByStepComponent };
//# sourceMappingURL=step-by-step-component.comp.js.map